export default __webpack_public_path__ + "static/media/right-arrow.e65af391.svg";